import { observer } from "mobx-react";
import React from "react";
import {
  Text,
  rem,
  Title,
  ActionIcon,
  Box,
  Group,
  Paper,
  Stack,
  Button,
} from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import { IconClock, IconEdit } from "@tabler/icons-react";
import { MODALS } from "../../helpers/constants";
import TopRightInfoCircle from "../dataDisplay/topRightInfoCircle";

const GuaranteedUptime = observer(({ cubby }: { cubby: Cubby }) => {
  const subscribeLink = "/rizvoice?subscribe=" + cubby.cubbyUuid;
  const subscribeCta =
    cubby.remainingDaysOfGuaranteedUptime == 0 ? "Get Uptime" : "Extend Uptime";
  return (
    <>
      <Paper withBorder style={{ position: "relative" }} p="md" radius="md">
        {cubby.remainingDaysOfGuaranteedUptime == 0 && (
          <Text size="lg">This Node Will Sleep</Text>
        )}

        {cubby.remainingDaysOfGuaranteedUptime > 0 && (
          <Text size="lg">Guaranteed Uptime</Text>
        )}

        {cubby.remainingDaysOfGuaranteedUptime == 0 && (
          <Stack>
            <Text size="sm">
              This node will automatically sleep when not in use.
            </Text>
            <Text size="sm">
              You can pay a Lightning invoice to keep it running 24/7.
            </Text>
          </Stack>
        )}
        <Stack>
          {cubby.remainingDaysOfGuaranteedUptime > 0 && (
            <Stack>
              <Text size="sm">
                This node is guaranteed to be online for{" "}
                {cubby.remainingDaysOfGuaranteedUptime} more days.
              </Text>
              <Text size="sm">
                You can pay a Lightning invoice to extend this guarantee.
              </Text>
            </Stack>
          )}

          <Button
            leftSection={<IconClock />}
            mt="md"
            component="a"
            href={subscribeLink}
          >
            {subscribeCta}
          </Button>
        </Stack>
      </Paper>
    </>
  );
});

export default GuaranteedUptime;
